import { TTransportType } from '@cian/chats-api/lib/browser-entry';
import * as React from 'react';

import { IUnderground } from '../../../types/offer';
import { TransportIcon } from '../transport_icon';
import { UndergroundIcon } from '../underground_icon';
import { WalkIcon } from '../walk_icon';

const style = require('./index.css');

interface IUndergroundProps {
  locationId?: number;
  underground: IUnderground;
}

const getIcon = (transportType: TTransportType) => (
  <span className={style['transport_type']}>{transportType === 'walk' ? <WalkIcon /> : <TransportIcon />}</span>
);

export const Underground: React.FunctionComponent<IUndergroundProps> = ({
  locationId,
  underground: { lineColor, name, time: rawTime, transportType: rawTransportType },
}) => {
  const time = rawTime ?? 0;
  const transportType = rawTransportType ?? 'transport';

  return (
    <span className={style['underground']}>
      <span className={style['underground-ico']}>
        <UndergroundIcon width={12} height={12} color={`#${lineColor}`} regionId={locationId} />
      </span>
      <span className={style['underground-header']}>{name}</span>

      {time > 0 ? (
        <span className={style['underground-distance']}>
          {getIcon(transportType)}
          {time}&nbsp;мин.&nbsp;
        </span>
      ) : (
        <span className={style['underground-distance']}>
          {getIcon(transportType)}
          &lt;1 мин.&nbsp;
        </span>
      )}
    </span>
  );
};
